if(window.innerWidth < 960){
    let menuItems = document.querySelectorAll('.menu .nav-main-item')
    let buttonMenu = document.querySelector('.nav-main_icon')
    menuItems.forEach(function(item) {
        item.addEventListener('click',function(){
            let activeItem = document.querySelector('.nav-main-item.active')
            this.classList.toggle('active')
            if(activeItem){
                activeItem.classList.remove('active')
            }
        })
    })
    buttonMenu.addEventListener('click',function(){
        let menuPosition = document.querySelector('#nav-main')
        menuPosition.classList.toggle('menuposition')
        document.querySelector('.identity').classList.toggle('identity--svgActive')
    })
}
if(window.innerWidth >= 960){
    let menuItems = document.querySelectorAll('.menu .nav-main-item')
    menuItems.forEach(function(item) {
        let menuPosition = document.querySelector('#nav-main')
        item.addEventListener('mouseenter',function(){
            this.classList.toggle('active')
            menuPosition.classList.toggle('menuposition')
            document.querySelector('.identity').classList.toggle('identity--svgActive')
        })
        item.addEventListener('mouseleave',function(){
            this.classList.remove('active')
            menuPosition.classList.remove('menuposition')
            document.querySelector('.identity').classList.toggle('identity--svgActive')
        })
    })
}


/* Menu text separation MOCHE */
    let menuEntry = document.getElementsByClassName('nav-main-link');
    let firstEntry = menuEntry[0].innerHTML;
    let secondEntry = menuEntry[1].innerHTML;
    let thirdEntry = menuEntry[2].innerHTML;

    const firstArray = firstEntry.split(" ");
    const secondArray = secondEntry.split(" ");
    const thirdArray = thirdEntry.split(" ");

    let firstFilter= firstArray.filter(Boolean);
    let secondFilter= secondArray.filter(Boolean);
    let thirdFilter= thirdArray.filter(Boolean);
  
    menuEntry[0].innerHTML = '<span class="nav-main-link__label">' + firstFilter[1] + '</span>' + "&nbsp;" + firstFilter[2];
    menuEntry[1].innerHTML = secondFilter[1] + "&nbsp;" + '<span class="nav-main-link__label">' + secondFilter[2] + "&nbsp;" + secondFilter[3] + '</span>';
    menuEntry[2].innerHTML = thirdFilter[1] + "&nbsp;" + '<span class="nav-main-link__label">' + thirdFilter[2] + '</span>';
